module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": _vm.mainTableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "prop": "courseName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开课部门",
      "prop": "deptName",
      "width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学分",
      "prop": "credit",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "prop": "totalHour",
      "width": "70px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "理论学时",
      "prop": "theoryHour",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实践学时",
      "prop": "trainingHour",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修读学期",
      "prop": "semesterNum",
      "formatter": _vm.semesterNumFormatter,
      "width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修读学时",
      "prop": "semesterLearnHour",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "prop": "examTypeName",
      "width": "50px",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importCourse
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4114d4c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/courseImport.vue
// module id = 1817
// module chunks = 502